import { Address } from '@pelicargo/types';
import { omit } from 'lodash';

import { COUNTRY_NAME_MAP, isoStateToName } from '../constants';

export const formatAddress = (address: Address, options: { direction?: 'row' | 'column' } = { direction: 'row' }) => {
  const isoState = isoStateToName(address?.state) ?? address?.state;
  const isoCountry = COUNTRY_NAME_MAP?.[address?.country] ?? address?.country;

  const parts = [
    address?.recipient,
    address?.line_one,
    address?.line_two,
    address?.city,
    isoState,
    address?.zip_code,
    isoCountry,
  ];

  if (options.direction === 'column') {
    const groupOne = [address?.recipient];
    const groupTwo = [address?.line_one, address?.line_two].filter(Boolean).join(' ');
    const groupThree = [address?.city, isoState, address?.zip_code].filter(Boolean).join(', ');
    const groupFour = [isoCountry].filter(Boolean).join(' ');
    return [groupOne, groupTwo, groupThree, groupFour].flat().filter(Boolean).join('\n');
  }

  return parts.filter(Boolean).join(', ');
};

// Returns the address without the zip code component
export const omitZipCode = (address: Address) => {
  if (!address) {
    return {
      recipient: '',
      line_one: '',
      line_two: '',
      country: '',
      state: '',
      city: '',
    };
  }

  const addressWithoutZip = omit(address, ['zip_code']);
  return addressWithoutZip;
};

// Splits the address into two parts, attempting to split at a space, but otherwise keeps the first part `length` characters
// 50 is an arbitrary reasonable default length
export const splitAddress = (address: Address, length: number = 50) => {
  const formatted = formatAddress(address);
  const spaceIndex = formatted.slice(formatted.length / 2).indexOf(' ');

  const splitIndex = spaceIndex === -1 ? length : formatted.length / 2 + spaceIndex;

  return [formatted.slice(0, splitIndex), formatted.slice(splitIndex + 1)];
};
